import { atom } from 'recoil';

// map of block keys to user answers

export const answersState = atom({
  key: 'answersState',
  default: {},
});
